import { Flex, Heading } from '@chakra-ui/react';
import { CustomerPrompt } from './CustomerPrompt';
import { CustomerPendingPaPrompt } from './CustomerPendingPaPrompt';
import { useUrlParamsProvider } from '@texas/components/shared/hooks/useUrlParams';
import { DailyArticlesReportPrompt } from './DailyArticlesReportPrompt';
import { useTranslation } from 'react-i18next';

export function PredefinedPrompts() {
  const { t } = useTranslation();
  const params = useUrlParamsProvider();

  return (
    <Flex flexDir="column" gap={2} alignSelf="start" pl={6}>
      <Heading opacity={0.3} fontSize="sm">
        {t('ai.predefinedPrompts.articlesHeader')}
      </Heading>
      <CustomerPrompt id={params['customerId']} />
      <Heading opacity={0.3} fontSize="sm">
        {t('ai.predefinedPrompts.productApprovalsHeader')}
      </Heading>
      <CustomerPendingPaPrompt id={params['customerId']} />
      <Heading opacity={0.3} fontSize="sm">
        {t('ai.predefinedPrompts.dailyHeader')}
      </Heading>
      <DailyArticlesReportPrompt />
    </Flex>
  );
}
